import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
import { CHOLA_COLORS } from '@/constants/filterStyles';

interface FilterSectionGroupProps {
  title: string;
  icon: SvgIconComponent;
  compact?: boolean;
  children: React.ReactNode;
}

export function FilterSectionGroup({
  title,
  icon: Icon,
  compact = false,
  children
}: FilterSectionGroupProps) {
  return (
    <Box sx={{ mb: compact ? 1 : { xs: 2, md: 3 } }}>
      <Typography variant="subtitle2" sx={{ 
        mb: compact ? 0.5 : 1.5, 
        color: CHOLA_COLORS.primary,
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        fontSize: compact ? '0.75rem' : '0.8125rem' // Increased from 0.65rem/0.875rem for better readability at 150% zoom
      }}>
        <Icon sx={{ fontSize: compact ? 14 : 16 }} /> {/* Slightly adjusted icon sizes */}
        {title}
      </Typography>
      <Grid container spacing={compact ? 0.5 : 1.5}>
        {children}
      </Grid>
    </Box>
  );
}

